<template>
  <div class="dev-env" v-show="is_dev_env && show">
    <p class="text-right ma-0" @click="show = false">
      <v-icon color="red">mdi-close-circle</v-icon>
    </p>
    <h1 class="red--text">
      เว็บไซต์นี้จัดทำเพื่อใช้ในการทดสอบเท่านั้น<br />
      This website is constructed for testing purposed only
    </h1>
  </div>
</template>

<script>
export default {
  data: () => ({
    show: true,
  }),
  computed: {
    is_dev_env() {
      if (process.env.VUE_APP_ENV !== "production") return true;
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dev-env {
  position: fixed;
  left: 30px;
  bottom: 30px;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 10px;
  z-index: 9999;
}
</style>
